module.exports = __webpack_public_path__ + "img/fusion_rune.a972bb80.png";